import React, { useState, useEffect, useRef } from "react";
import ArchetypeList from "./ArchetypeList";
import ArchetypeForm from "./ArchetypeForm";
import { usePopup } from "./PopupContext";

const ManageArchetypes = (props) => {
    
    const hasFetched = useRef(false)
    const [archetypes, setArchetypes] = useState([]);
    const [showArchetypeDetails, setShowArchetypeDetails] = useState(false);
    const [selectedArchetype, setSelectedArchetype] = useState(null);
    const pop = usePopup()
    
    const onShowArchetypeDetails = (archetype) => {
        setSelectedArchetype(archetype);
        setShowArchetypeDetails(true);
    }

    // Fetch archetype data from API
    const fetchArchetypes = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/guide-types`, {
            headers: {
                'Authorization': `Bearer ${window.localStorage.getItem('adminToken')}`
            }
        });
        const data = await response.json();
        if (data.success) {
            setArchetypes(data.guideTypes);
        } else {
            console.error("Failed to fetch guide-types (archetypes)");
        }
    };

    const updateArchetype = async (archetype) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/guide-type/`, {
            method: 'PATCH',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${window.localStorage.getItem('adminToken')}`
            },
            body: JSON.stringify(archetype)
        });
        const data = await response.json();
        if (data.success) {
            setShowArchetypeDetails(false);
            fetchArchetypes();
        } else {
            console.error("Failed to fetch archetypes");
        }
    }

    const rejectArchetype = async (archetype) => {
        const yes = await pop(`Are you sure you'd like to completely remove ${archetype.title}?`, 'confirm')
        if (yes) {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/guide-type/${archetype._id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem('adminToken')}`
                }
            });
            const data = await response.json();
            if (data.success) {
                setShowArchetypeDetails(false);
                fetchArchetypes();
            } else {
                console.error("Failed to reject archetype");
            }
        }
    };

    useEffect(() => {
        // prevents double fetching
        if (hasFetched.current) return
        hasFetched.current = true
        fetchArchetypes();
    }, []);

    return (
        <section className="main-body-section manage-applicants-section">
            {!showArchetypeDetails && archetypes.length > 0 && <ArchetypeList archetypes={archetypes} onShowArchetypeDetails={onShowArchetypeDetails} />}
            {!showArchetypeDetails && archetypes.length === 0 && (
                <div style={{ textAlign: "center", marginTop: 20 }}>
                    <h3>No archetypes found.</h3>
                    <p>Please check back later.</p>
                </div>
            )}
            {showArchetypeDetails && selectedArchetype && (
                <ArchetypeForm 
                    selectedArchetype={selectedArchetype}
                    setShowArchetypeDetails={setShowArchetypeDetails}
                    rejectArchetype={rejectArchetype}
                    updateArchetype={updateArchetype} />
            )}
        </section>
    );
}

export default ManageArchetypes;